import Configuration from "./../config";
import { getUserFullName, getAddressDescription } from "./util";
import {
  getSessionUser,
  isGroupUser,
  isSelfStudyUser,
  isOneOnOneUser,
  isUserAdmin,
  isUserCompanyManager,
  isUserContentAdmin,
  isUserStudent,
  isUserTeacher,
  isUserTeamManager,
} from "./authUtil";

// intercom app_id
const INTERCOM_APP_ID = Configuration.INTERCOM_APP_ID;

export function initializeIntercom() {
  // Intercom messenger can prevent test system from clicking
  // on dialog submit buttons. That's why we disable intercom for tests
  // or if it's requested.
  if (!Configuration.SHOW_INTERCOM) {
    return;
  }

  (function () {
    var w = window;
    var ic = w.Intercom;
    if (typeof ic === "function") {
      ic("reattach_activator");
      ic("update", undefined); //ic("update", intercomSettings);
    } else {
      var d = document;
      var i = function () {
        i.c(arguments);
      };
      i.q = [];
      i.c = function (args) {
        i.q.push(args);
      };
      w.Intercom = i;
      function l() {
        var s = d.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.src = "https://widget.intercom.io/widget/" + INTERCOM_APP_ID;
        var x = d.getElementsByTagName("script")[0];
        x.parentNode.insertBefore(s, x);
      }
      if (w.attachEvent) {
        w.attachEvent("onload", l);
      } else {
        w.addEventListener("load", l, false);
      }
    }
  })();
}

export class Event {
  static BOOK = "session-booked";
  static CANCEL = "session-cancelled";
  static RESCHEDULE = "session-rescheduled";
}

export function initIntercom(user) {
  let intercomSettings = {
    app_id: INTERCOM_APP_ID,
  };
  if (user) {
    intercomSettings = {
      app_id: INTERCOM_APP_ID,
      name: getUserFullName(user.profile),
      email: user.profile.email,
      user_id: user.id,
      roles: JSON.stringify(user.roles),
      saved_address: getAddressDescription(user.profile.address),
    };
    if (user.profile && user.profile.native_language) {
      intercomSettings.native_language = user.profile.native_language;
    }

    if (user.student) {
      let studentType = null;
      if (isOneOnOneUser(user)) {
        studentType = "one-on-one";
      } else if (isGroupUser(user)) {
        studentType = "group";
      } else if (isSelfStudyUser(user)) {
        studentType = "library";
      }
      intercomSettings.student_type = studentType;
      intercomSettings.self_study_type = user.student.has_pro_access
        ? "Self-study-PRO"
        : "Self-study-BASIC";
    }
    let userType;
    if (isUserCompanyManager(user)) {
      userType = "company-manager";
    } else if (isUserTeamManager(user)) {
      userType = "team-manager";
    } else if (isUserStudent(user)) {
      userType = "student";
    } else if (isUserTeacher(user)) {
      userType = "instructor";
    } else if (isUserContentAdmin(user)) {
      userType = "content-manager";
    } else if (isUserAdmin(user)) {
      userType = "admin";
    }
    intercomSettings.user_type = userType;

    if (user.company) {
      intercomSettings.company = {
        id: user.company.id,
        name: user.company.name,
      };
      if (user.team) {
        intercomSettings.company.team_name = user.team.name;
      }
    }

    for (const key in user.features) {
      intercomSettings["feature_" + key] = user.features[key];
    }
  }
  window.Intercom && window.Intercom("boot", intercomSettings);
}

export function updateIntercom() {
  initIntercom(getSessionUser());
  window.Intercom && window.Intercom("update");
}

export function shutDownIntercom() {
  window.Intercom && window.Intercom("shutdown");
}

export function trackEvent(eventName, metadata) {
  window.Intercom && window.Intercom("trackEvent", eventName, metadata);
}

export function getIntercomAppId() {
  return INTERCOM_APP_ID;
}

export function getConversationUrl(userId) {
  return (
    "https://app.intercom.io/apps/" + getIntercomAppId() + "/users/show?user_id=" + userId
  );
}
